'use strict';

import $ from 'jquery';
import toast from 'react-hot-toast';
import _ from 'underscore';
import { getCreatorApiUrl, getConsumerApiUrl } from './api-urls';
import auth from './auth';
import axios from 'axios';
import { RawWorkout } from '../new/pages/collection/workouts/workouts.domain';
import {
  ApiAdminProgramUpsertRequest,
  ApiInfluencerUpsertRequest,
} from '@client/new/api/types';
import { FullMedia } from '@client/new/common/videos/GQLTypes';
import { WorkoutTiny } from '../../generated/graphql';

$.ajaxSetup({
  beforeSend: function (xhr) {
    xhr.setRequestHeader('Authorization', auth.getToken());
  },
  headers: {
    // 'X-client-name': 'admin-panel-ajax', // NOTE: video.integration.fitner.co CORS doesn't allow
  },
});

/**
 *
 * @param onChange - callback function that takes a number between 0 and 1
 */
function trackUploadProgress(onChange: (x: number) => void) {
  return function () {
    const xhr = new window.XMLHttpRequest();
    xhr.upload.addEventListener(
      'progress',
      function (evt) {
        if (evt.lengthComputable) {
          const percentComplete = evt.loaded / evt.total;
          onChange(percentComplete);
        }
      },
      false,
    );
    return xhr;
  };
}

const unauthorizedMessage =
  '[Ajax] Could not fetch data, probably because the auth token expired, or you logged in from Postman after starting the browser session (which replaced your token).';

function getInfluencers(id, mode = undefined) {
  return new Promise((resolve, reject) => {
    let url;
    if (id) {
      url = `/admin-influencers/${id ? id : ''}`;
    } else if (mode) {
      url = `/admin-influencers?mode=${mode}`;
    } else {
      url = `/admin-influencers`;
    }
    console.log('url', url);
    $.ajax({
      url: getCreatorApiUrl(url),
      type: 'GET',

      success(data) {
        resolve(data);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        console.log('[Ajax] Error fetching Influencers.', e);
        reject(e);
      },
    });
  });
}

function upsertInfluencer(postData: ApiInfluencerUpsertRequest) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl('/admin-influencers'),
      type: 'POST',
      //http://stackoverflow.com/questions/5927742/post-array-data-to-express-gets-parsed-out-as-json
      contentType: 'application/json',
      data: JSON.stringify(postData),

      success(response) {
        resolve(response);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        console.log('[Ajax] Error upserting Influencer.', e);
        reject(e);
      },
    });
  });
}

function deleteInfluencer(id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl('/admin-influencers'),
      type: 'DELETE',
      contentType: 'application/json',
      data: JSON.stringify({ id }),

      success(response) {
        resolve(response);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        console.log('[Ajax] Error deleting Influencer.', e);
        reject(e);
      },
    });
  });
}

function getWorkout(id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl(`/admin-workouts/${id}`),
      type: 'GET',

      success(data) {
        resolve(data);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        console.log('[Ajax] Error fetching Workout.', e);
        reject(e);
      },
    });
  });
}

function cloneWorkout(workoutId: number, delta?: Partial<RawWorkout>) {
  console.log('[Ajax] cloneWorkout() called...', workoutId, delta);
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl(`/admin-workouts/${workoutId}/clone`),
      type: 'GET',

      success(data) {
        if (delta) {
          upsertWorkout({ ...data, ...delta }).then(resolve);
        } else resolve(data);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        reject(e);
      },
    });
  });
}

function archiveWorkout(workoutId: number) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl(`/admin-workouts/${workoutId}/archive`),
      type: 'GET',

      success(data) {
        resolve(data);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        reject(e);
      },
    });
  });
}

function getProgramList(influencerId) {
  let url = `/admin-programs?influencerId=${influencerId}`;
  console.log(`[Ajax] ${url} called...`);
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl(url),
      type: 'GET',

      success(data) {
        console.log('[Ajax] Fetched Program list.', data);
        resolve(data);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        } else if (e.status === 404) {
          console.log('Influencer or Program not found.', e);
          reject('notfound');
          return;
        }
        console.log('[Ajax] Error fetching Program list.', e);
        reject(e);
      },
    });
  });
}

function getProgram(programId) {
  let url = `/admin-programs/${programId}`;
  console.log(`[Ajax] ${url} called...`);
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl(url),
      type: 'GET',

      success(data) {
        console.log('[Ajax] Fetched Program.', data);
        resolve(data);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        } else if (e.status === 404) {
          console.log('Influencer or Program not found.', e);
          reject('notfound');
          return;
        }
        console.log('[Ajax] Error fetching Program.', e);
        reject(e);
      },
    });
  });
}

function upsertProgram(postData: ApiAdminProgramUpsertRequest) {
  console.log('[Ajax] upsertProgram() called...');
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl('/admin-programs'),
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(postData),

      success(response) {
        console.log('[Ajax] Upserted Program.');
        resolve(response);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        const error =
          e.responseJSON?.status === 'error'
            ? e.responseJSON.msg
            : `You're experiencing connection issues, please try again`;
        toast.error(error);
        console.log('[Ajax] Error upserting Program.', e);
        reject(e);
      },
    });
  });
}

function reorderProgram(programId: number, workoutIds: Array<number>) {
  let url = `/admin-programs/${programId}/reorder`;
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl(url),
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({ workoutIds }),

      success(response) {
        resolve(response);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        reject(e);
      },
    });
  });
}

function upsertWorkout(postData: Partial<WorkoutTiny>): Promise<RawWorkout> {
  console.log('[Ajax] upsertWorkout() called...', postData);
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl('/admin-workouts'),
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(postData),

      success(response) {
        resolve(response);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        const error =
          e.responseJSON?.status === 'error'
            ? e.responseJSON.msg
            : `You're experiencing connection issues, please try again`;
        toast.error(error);
        console.log('[Ajax] Error upserting Workout.', e);
        reject(e);
      },
    });
  });
}

function deleteWorkout(workoutId: number) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl('/admin-workouts'),
      type: 'DELETE',
      contentType: 'application/json',
      data: JSON.stringify({ id: workoutId }),

      success(response) {
        resolve(response);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        reject(e);
      },
    });
  });
}

export type PortalUser = {
  id: number;
  username: string;
  role: number;
  email: string;
  firstName: string;
  lastName: string;
  isActive: boolean;
  influencerId: number;
};
function getPortalUsers(id?: number): Promise<PortalUser[]> {
  return new Promise((resolve, reject) => {
    let url = `/admin-portal-users/${id ? id : ''}`;
    $.ajax({
      url: getCreatorApiUrl(url),
      type: 'GET',
      success(data) {
        resolve(data);
      },
      error(e) {
        console.log(e);
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        console.log('[Ajax] Error fetching Portal Users.', e);
        reject(e);
      },
    });
  });
}

function upsertPortalUser(postData) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl('/admin-portal-users'),
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(postData),

      success(response) {
        resolve(response);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        console.log('[Ajax] Error upserting PortalUser.', e);
        reject(e);
      },
    });
  });
}

function createUserAndInfluencer(postData) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl('/admin-portal-users-simplified'),
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(postData),

      success(response) {
        return resolve(response);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          return reject('auth');
        }
        console.log('[Ajax] Error upserting PortalUser.', e);
        return reject(e);
      },
    });
  });
}

function deletePortalUser(id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl('/admin-portal-users'),
      type: 'DELETE',
      contentType: 'application/json',
      data: JSON.stringify({ id: id }),

      success(response) {
        resolve(response);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        console.log('[Ajax] Error deleting PortalUser.', e);
        reject(e);
      },
    });
  });
}

type UploadConfig = {
  skipCompression?: boolean;
  onProgress?: (x: number) => void;
  creatorId?: number;
  tags?: string[];
  source?: string;
};

async function upload(
  file: File,
  creatorId: number,
  {
    skipCompression = false,
    onProgress = () => {},
    tags = [],
  }: UploadConfig = {},
) {
  const adminUploadUrl = `${
    import.meta.env.VITE_ADMIN_UPLOAD_BASE_URL
  }/admin-upload`;

  // NOTE: this is to bypass chrome bug related to react-dropzone:
  // https://github.com/react-dropzone/react-dropzone/issues/1290#issuecomment-1665516575
  const blob = await fetch(URL.createObjectURL(file)).then((r) => r.blob());
  var formData = new FormData();
  const fixedFile = new File([blob], file.name, { type: file.type });
  formData.append('media', fixedFile);

  const format = file.type.startsWith('image')
    ? 'image'
    : file.type.startsWith('audio')
    ? 'audio'
    : 'video';

  const url = new URL(adminUploadUrl);
  url.searchParams.append('creatorId', String(creatorId));
  url.searchParams.append('compress', skipCompression ? 'skip' : 'true');
  url.searchParams.append('format', format); // NOTE: should not be needed

  return new Promise<FullMedia>((resolve, reject) => {
    $.ajax({
      url: url.toString(),
      type: 'POST',
      data: formData,
      cache: false,
      contentType: false,
      processData: false,
      success(response) {
        resolve(response);
      },
      error(xhr, status, e) {
        console.log('XHR:', xhr);
        console.log('XHR.responseText:', xhr.responseText);
        console.log('STATUS:', status);
        console.log('XHR.status:', xhr.status);
        console.log('ERROR:', e);
        if (xhr.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        console.log('[Ajax] Error uploading file.', xhr);
        reject(xhr);
      },
      xhr: trackUploadProgress(onProgress),
      timeout: 600000,
    });
  });
}

function searchExercise(str) {
  console.log('[Ajax] searchExercise() called.', str);
  return new Promise((resolve, reject) => {
    if (!str || str.length < 2) {
      resolve([]);
      return;
    }
    $.ajax({
      url: getCreatorApiUrl(`/admin-exercise-search?q=${str}`),
      type: 'GET',

      success(response) {
        console.log('[Ajax] searchExercise() received response.', response);
        response = _.pluck(response, 'name');
        resolve(response);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        console.log('[Ajax] searchExercise() error.', e);
        reject(e);
      },
    });
  });
}

function getExerciseTemplates(influencerId, target) {
  return new Promise((resolve, reject) => {
    if (!influencerId) reject('Missing influencerId.');

    var url = `/admin-exercise-templates?influencerId=${influencerId}`;
    if (target) url += `&target=${target}`;

    $.ajax({
      url: getCreatorApiUrl(url),
      type: 'GET',

      success(data) {
        resolve(data);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        console.log('[Ajax] Error fetching ExerciseTemplate list.', e);
        reject(e);
      },
    });
  });
}

function getExerciseTemplate(id) {
  return new Promise((resolve, reject) => {
    if (!id) reject('Missing identifier.');

    $.ajax({
      url: getCreatorApiUrl(`/admin-exercise-templates/${id}`),
      type: 'GET',

      success(data) {
        resolve(data);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        console.log('[Ajax] Error fetching ExerciseTemplate.', e);
        reject(e);
      },
    });
  });
}

function upsertExerciseTemplate(data) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl('/admin-exercise-templates'),
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(data),

      success(response) {
        resolve(response);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        console.log('[Ajax] Error upserting ExerciseTemplate.', e);
        reject(e);
      },
    });
  });
}

function upsertCustomColorSchema(influencerId, data) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl(`/admin-influencers/${influencerId}/color-schema`),
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(data),

      success(response) {
        resolve(response);
      },
      error(e) {
        if (e.status === 401) {
          reject('auth');
          return;
        }
        reject(e);
      },
    });
  });
}

function deleteExerciseTemplate(id) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl('/admin-exercise-templates'),
      type: 'DELETE',
      contentType: 'application/json',
      data: JSON.stringify({ id }),

      success(response) {
        resolve(response);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        console.log('[Ajax] Error deleting ExerciseTemplate.', e);
        reject(e);
      },
    });
  });
}

function getKeywordList() {
  console.log('[Ajax] getKeywordList() called...');
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getConsumerApiUrl('/api'),
      type: 'GET',
      success(response) {
        let keywords = _.map(response.keywords, (k) => {
          return {
            id: k,
            value: k,
          };
        });
        console.log('[Ajax] Fetched keywords.', keywords);
        resolve(keywords);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        console.log('[Ajax] Error fetching keyword list.', e);
        reject(e);
      },
    });
  });
}

function resetStripe(postData) {
  console.log('[Ajax] resetStripe() called...');
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl(
        '/admin-influencers/' + postData.id + '/remove-stripe',
      ),
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(postData),

      success(response) {
        console.log('[Ajax] Stripe reset.');
        resolve(response);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        console.log('[Ajax] Error reseting Stripe.', e);
        reject(e);
      },
    });
  });
}

function getConfigFile() {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl('/admin/config-file'),
      type: 'GET',
      contentType: 'application/json',

      success(response) {
        console.log('[Ajax] Fetch config file.');
        resolve(response);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        console.log('[Ajax] Error fetching config file.', e);
        reject(e);
      },
    });
  });
}

function updateConfigFile(configFile) {
  return new Promise((resolve, reject) => {
    const data = {
      configFile,
    };
    $.ajax({
      url: getCreatorApiUrl('/admin/config-file'),
      type: 'PUT',
      contentType: 'application/json',
      data: JSON.stringify(data),

      success(response) {
        console.log('[Ajax] Update config file.');
        resolve(response);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        console.log('[Ajax] Update config file.', e);
        reject(e);
      },
    });
  });
}

export enum FreeSubscriptionType {
  ANNUAL = 'ANNUAL',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
}

enum SourceClassification { // TODO: move to common-enums
  PaidSubscription,
  GiftedAnnualSubscription,
  FreeSubscription,
  MigratedSubscription,
  SideDealSubscription,
}

const generateFreeSubscription = async (dto: {
  email: string;
  subscriptionType: FreeSubscriptionType;
  sourceInfluencerId?: number;
  note?: string;
}) => {
  const endpoint = getCreatorApiUrl(`/free-subscription/generate-single`);

  const token = auth.getToken();

  const { data } = await axios.post(
    endpoint,
    { ...dto, sourceClassification: SourceClassification.FreeSubscription },
    {
      headers: {
        Authorization: token,
      },
    },
  );

  return data;
};

function fetchWorkoutComments(workoutId) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl(`/admin-workouts/${workoutId}/posts`),
      type: 'GET',

      success(data) {
        resolve(data);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        console.log('[Ajax] Error fetching Workout.', e);
        reject(e);
      },
    });
  });
}

function fetchAvailableWorkoutTags() {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl(`/admin-workouts-tags/`),
      type: 'GET',

      success(data) {
        resolve(data);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        console.log('[Ajax] Error fetching workout tags.', e);
        reject(e);
      },
    });
  });
}

function attachWorkoutTags(workoutId, tags) {
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl(`/admin-workouts-tags/${workoutId}`),
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(tags ?? []),

      success(data) {
        resolve(data);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        console.log('[Ajax] Error fetching workout tags.', e);
        reject(e);
      },
    });
  });
}

function getOtpAutoPayoutsEnabledState(stripeUserId: string): Promise<boolean> {
  console.log('[Ajax] getOtpAutoPayoutsEnabledState() called...');
  return new Promise((resolve, reject) => {
    $.ajax({
      url: getCreatorApiUrl(`/admin/otp-auto-payouts-enabled/${stripeUserId}`),
      type: 'GET',
      success(response) {
        const otpAutoPayoutsEnabled = response;
        resolve(otpAutoPayoutsEnabled);
      },
      error(e) {
        if (e.status === 401) {
          console.log(unauthorizedMessage);
          reject('auth');
          return;
        }
        console.log('[Ajax] Error fetching payout state.', e);
        reject(e);
      },
    });
  });
}

const exports = {
  getInfluencers,
  upsertInfluencer,
  deleteInfluencer,
  getWorkout,
  upsertWorkout,
  deleteWorkout,
  archiveWorkout,
  cloneWorkout,
  getPortalUsers,
  upsertPortalUser,
  deletePortalUser,
  upload,
  searchExercise,
  getExerciseTemplates,
  getExerciseTemplate,
  upsertExerciseTemplate,
  deleteExerciseTemplate,
  getProgramList,
  getProgram,
  upsertProgram,
  reorderProgram,
  getKeywordList,
  resetStripe,
  createUserAndInfluencer,
  upsertCustomColorSchema,
  getConfigFile,
  updateConfigFile,
  generateFreeSubscription,
  fetchWorkoutComments,
  fetchAvailableWorkoutTags,
  attachWorkoutTags,
  getOtpAutoPayoutsEnabledState,
};

export default exports;
export {
  getInfluencers,
  upsertInfluencer,
  deleteInfluencer,
  getWorkout,
  upsertWorkout,
  deleteWorkout,
  archiveWorkout,
  cloneWorkout,
  getPortalUsers,
  upsertPortalUser,
  deletePortalUser,
  upload,
  searchExercise, // NOTE: not used
  getExerciseTemplates,
  getExerciseTemplate,
  upsertExerciseTemplate,
  deleteExerciseTemplate,
  getProgramList,
  getProgram,
  upsertProgram,
  reorderProgram,
  getKeywordList,
  resetStripe,
  createUserAndInfluencer,
  upsertCustomColorSchema,
  getConfigFile,
  updateConfigFile,
  generateFreeSubscription,
  fetchWorkoutComments,
  fetchAvailableWorkoutTags,
  attachWorkoutTags,
  getOtpAutoPayoutsEnabledState,
};
